import React from 'react';

function SkillCard(props) {
    return (
        <div className="insertData">
            <p>{props.skill}</p>
            <p id="proficiency">{props.level}</p>
        </div>
    );
}

export default SkillCard;